var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRecommendationsMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.9148C0.558172 12.9148 0.2 13.273 0.2 13.7148C0.2 14.1567 0.558172 14.5148 1 14.5148V12.9148ZM1 14.5148H10.5238V12.9148H1V14.5148Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.81914C0.558172 6.81914 0.2 7.17731 0.2 7.61914C0.2 8.06097 0.558172 8.41914 1 8.41914V6.81914ZM1 8.41914H13.1905V6.81914H1V8.41914Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0.723437C0.558172 0.723437 0.2 1.08161 0.2 1.52344C0.2 1.96527 0.558172 2.32344 1 2.32344V0.723437ZM1 2.32344H13.1905V0.723437H1V2.32344Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 1C19.8 0.558172 19.4418 0.2 19 0.2C18.5582 0.2 18.2 0.558172 18.2 1L19.8 1ZM18.4343 16.5657C18.7467 16.8781 19.2533 16.8781 19.5657 16.5657L24.6569 11.4745C24.9693 11.1621 24.9693 10.6556 24.6569 10.3431C24.3444 10.0307 23.8379 10.0307 23.5255 10.3431L19 14.8686L14.4745 10.3431C14.1621 10.0307 13.6556 10.0307 13.3431 10.3431C13.0307 10.6556 13.0307 11.1621 13.3431 11.4745L18.4343 16.5657ZM18.2 1L18.2 16L19.8 16L19.8 1L18.2 1Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecommendationsMobile);
export default __webpack_public_path__ + "static/media/icon-recommendations-mobile.a65462525293b23a22676e276cd17c6c.svg";
export { ForwardRef as ReactComponent };